import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import imageUpload from "components/imageUpload.vue";
export default {
  data: function data() {
    return {
      checkList: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      stuName: "",
      schoolName: "",
      idCard: "",
      certificateNum: "",
      examinationTypeId: "",
      examinationGradeId: "",
      list: [],
      from: {
        id: "",
        name: "",
        certificateCover: ""
      },
      files: [],
      urlAliyunOSS: "/api/XOrg/osssign/getsign",
      //编辑信息
      dialogFormVisible: false,
      //导入
      ImportDialogVisible: false,
      uploadUrl: "/api/XOrg/CertificateManager/uploadExcel",
      fileList: [],
      //导入文件
      errorList: [],
      //错误信息
      certTypeList: [],
      certGradeList: [],
      certTypeId: "",
      searchCertTypeList: [],
      searCertGradeList: [],
      // 批量删除
      DeleteAllDialogVisible: false,
      deleteStartTime: "",
      deleteEndTime: "",
      isCJ: 1,
      isZJ: 1,
      isGJ: 1
    };
  },
  components: {
    imageUpload: imageUpload
  },
  created: function created() {
    this.getStudentResultInfo(); // this.getCertificateType();
    // this.getSearchCertificateType();
  },
  methods: {
    handleCheckedCitiesChange: function handleCheckedCitiesChange(val) {},
    deleteAll: function deleteAll() {
      var _this = this;

      var that = this;
      this.$confirm("此操作将删除该时间段证书数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        that.$http.post("/api/XOrg/CertificateManager/deleteCertificateAll", {
          startTime: _this.deleteStartTime,
          endTime: _this.deleteEndTime
        }).then(function (rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.DeleteAllDialogVisible = false;
            that.getStudentResultInfo();
          } else {
            that.$message.warning(rst.msg);
          }
        });
      });
    },
    cancelDeleteAll: function cancelDeleteAll() {
      this.DeleteAllDialogVisible = false;
      this.deleteStartTime = "";
      this.deleteEndTime = "";
    },
    getSearchCertificateType: function getSearchCertificateType() {
      var that = this;
      this.$http.post("/api/XOrg/CertificateTypeManager/getCertificateType").then(function (rst) {
        if (rst.code > 0) {
          that.searchCertTypeList = rst.list;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    getSearchCertificateGrade: function getSearchCertificateGrade() {
      var that = this;
      this.$http.post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
        typeId: this.examinationTypeId
      }).then(function (rst) {
        if (rst.code > 0) {
          that.searCertGradeList = rst.list;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    getCertificateType: function getCertificateType() {
      var that = this;
      this.$http.post("/api/XOrg/CertificateTypeManager/getCertificateType").then(function (rst) {
        if (rst.code > 0) {
          that.certTypeList = rst.list;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    typeChnage: function typeChnage() {
      // this.getCertificateGrade();
      this.from.examinationGradeId = "";
    },
    getCertificateGrade: function getCertificateGrade() {
      var that = this;
      this.$http.post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
        typeId: this.from.examinationTypeId
      }).then(function (rst) {
        if (rst.code > 0) {
          that.certGradeList = rst.list;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    cancelInfo: function cancelInfo() {
      this.from.name = "";
      this.dialogFormVisible = false;
    },
    onSuccess: function onSuccess(res) {
      if (res.code < 0) {
        if (res.code === -5) {
          this.errorList = res.list;
        } else {
          this.$message.warning(res.msg);
        }
      } else {
        this.ImportDialogVisible = false;
        this.$message.success("导入成功");
        this.fileList = [];
        this.getStudentResultInfo();
      }
    },
    //清除数据
    cancel: function cancel() {
      this.ImportDialogVisible = false;
      this.fileList = [];
    },
    addInfo: function addInfo() {
      this.dialogFormVisible = true;
    },
    //编辑
    editInfo: function editInfo() {
      var that = this;
      debugger;
      this.$http.post("/api/XOrg/Certificate/addOrEditCertificate", {
        id: this.from.id,
        name: this.from.name,
        certificateCover: this.from.certificateCover
      }).then(function (rst) {
        if (rst.code > 0) {
          that.$message.success(rst.msg);
          that.cancelInfo();
          that.getStudentResultInfo();
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    //弹出框赋值
    handleEdit: function handleEdit(row) {
      this.from.id = row.id;
      this.from.name = row.CertificateName;
      this.from.certificateCover = row.CertificateCover;
      this.dialogFormVisible = true;
    },
    //删除
    deleteInfo: function deleteInfo(id) {
      var that = this;
      this.$confirm("此操作将删除该证书数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        that.$http.post("/api/XOrg/Certificate/deleteCertificate", {
          ids: id
        }).then(function (rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.getStudentResultInfo();
          } else {
            that.$message.warning(rst.msg);
          }
        });
      });
    },
    //获取列表
    getStudentResultInfo: function getStudentResultInfo() {
      var that = this;
      this.$http.post("/api/XOrg/Certificate/getCertificateList").then(function (rst) {
        if (rst.code > 0) {
          that.list = rst.list;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    }
  }
};